import { Rms }     from './rms'
import { MockRms } from './mock-rms'

const RmsLoader = (isMock, filePaths = {}, include = true) => {
    if (!include) return {}

    if (isMock) {
        MockRms.setFilePaths(filePaths)
        return MockRms
    }

    return Rms
}

export { RmsLoader }
